import { render, staticRenderFns } from "./BackerCenterUpdateFeedList.vue?vue&type=template&id=5eed54fa"
import script from "./BackerCenterUpdateFeedList.vue?vue&type=script&lang=js"
export * from "./BackerCenterUpdateFeedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports